import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Construction } from 'lucide-react';
export function ModulePlaceholder({
  title,
  description
}: {
  title: string;
  description?: string;
}) {
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6 h-full min-h-[60vh]" data-id="element-2525">
      <Card className="bg-card border-border/50 flex-1 flex flex-col items-center justify-center text-center p-12" data-id="element-2526">
        <div className="size-20 rounded-full bg-muted/30 border border-border/50 flex items-center justify-center mb-6" data-id="element-2527">
          <Construction className="size-10 text-muted-foreground" data-id="element-2528" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2" data-id="element-2529">
          {title}
        </h2>
        <p className="text-muted-foreground max-w-md" data-id="element-2530">
          {description || `Modul ${title} sedang dalam tahap pengembangan. Fitur ini akan tersedia pada rilis berikutnya.`}
        </p>
      </Card>
    </div>;
}